import { ReactNode } from 'react';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';

interface TransferListLayoutProps {
  leftList: ReactNode;
  rightList: ReactNode;
  onMoveRight: () => void;
  onMoveLeft: () => void;
  moveRightDisabled: boolean;
  moveLeftDisabled: boolean;
}

export const SharedTransferListLayout = ({
  leftList,
  rightList,
  onMoveRight,
  onMoveLeft,
  moveRightDisabled,
  moveLeftDisabled,
}: TransferListLayoutProps) => {
  return (
    <Grid
      container
      spacing={2}
      sx={{ justifyContent: 'center', height: '100%', width: '100%' }}
    >
      <Grid
        container
        size={{ xs: 12, sm: 5.5 }}
        sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}
      >
        {leftList}
      </Grid>

      <Grid
        container
        size={{ xs: 12, sm: 1 }}
        sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}
      >
        <Grid
          container
          direction="column"
          sx={{ alignItems: 'center', pt: 2, width: '100%' }}
        >
          <Button
            sx={{ my: 0.5, width: '100%', minWidth: 0, maxWidth: '4.2vw' }}
            variant="contained"
            size="small"
            onClick={onMoveRight}
            disabled={moveRightDisabled}
            aria-label="move selected right"
          >
            &gt;
          </Button>
          <Button
            sx={{ my: 0.5, width: '100%', minWidth: 0, maxWidth: '4.2vw' }}
            variant="contained"
            size="small"
            onClick={onMoveLeft}
            disabled={moveLeftDisabled}
            aria-label="move selected left"
          >
            &lt;
          </Button>
        </Grid>
      </Grid>

      <Grid
        container
        size={{ xs: 12, sm: 5.5 }}
        sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}
      >
        {rightList}
      </Grid>
    </Grid>
  );
};
